module.exports = __webpack_public_path__ + "static/img/uob.756ea0e6.svg";